/**
 * Technician-van marker artwork. A single designer-supplied top-down render (master:
 * public/van-icon.png, prepared into public/van-marker.png — trimmed, rotated to point
 * north, padded square so rotation never clips, and downscaled). The symbol layer
 * rotates it by the live heading; vehicle state is deliberately NOT encoded in the
 * marker — it is shown on the hover card and the van details panel instead.
 */

/**
 * Logical (CSS px) size of the padded-square sprite at the zoom ramp's full scale. The
 * van artwork occupies ~42×94 of the 108px source, so at 108 the visible van is ~94px
 * long — the designer's street-level reference, where the van measures ~95×42px against
 * 52px-wide POI pins (roughly 1.6× a pin's height). The van layer's zoom ramp scales
 * this down on wider views.
 */
export const VAN_MARKER_SIZE = 108;

export const VAN_MARKER_IMAGE_ID = 'van-marker';

export const VAN_MARKER_ASSET_PATH = '/van-marker.png';

/** The source sprite's pixel size — MapLibre derives the on-screen size from this. */
const VAN_MARKER_SOURCE_SIZE = 108;

/** Maps the source onto VAN_MARKER_SIZE logical pixels — 1:1 for the current sprite, so
 * high-DPI displays upsample it; a larger master would restore their crispness. */
export const VAN_MARKER_PIXEL_RATIO = VAN_MARKER_SOURCE_SIZE / VAN_MARKER_SIZE;
